var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllCollectionFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 17.3333C20.6667 17.7754 20.4911 18.1993 20.1785 18.5118C19.8659 18.8244 19.442 19 19 19H5.66667C5.22464 19 4.80072 18.8244 4.48816 18.5118C4.17559 18.1993 4 17.7754 4 17.3333V5.66667C4 5.22464 4.17559 4.80072 4.48816 4.48816C4.80072 4.17559 5.22464 4 5.66667 4H9.83333L11.5 6.5H19C19.442 6.5 19.8659 6.67559 20.1785 6.98816C20.4911 7.30072 20.6667 7.72464 20.6667 8.16667V17.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllCollectionFill);
export default __webpack_public_path__ + "static/media/iconImgAllCollectionFill.b1bd669ede926c774f4443841f0c352c.svg";
export { ForwardRef as ReactComponent };